export enum UserTypeEnum {
  NONE = -1,
  PHYSICAL_PERSON = 0,
  LEGAL_PERSON = 1,
  CORBAN = 2,
  CORBAN_CONTRIBUTOR = 3,
  LEGAL_PERSON_CONTRIBUTOR = 4
}
